/**
 * TextOverflow module
 * - looks at elements with `:after` with content `text-overflow:true`
 * - line clamps them to max height (cross browser)
 */

;var TextOverflow = (function($) { // eslint-disable-line no-extra-semi

    /**
     * TextOverflow constructor
     * @constructor
     */
    TextOverflow = function() {
        /**
         * Throw an error if 'pseudo-property.js' is not in the project
         */
        if ($.fn.pseudoProperty === undefined) {
            throw 'pseudoProperty module not loaded';
        }

        /**
         * Throw an error if dotdotdot is not present
         */
        if ($.fn.dotdotdot === undefined) {
            throw 'dotdotdot not loaded';
        }
    };

    /**
     * Initialize line clamping
     *
     * @param idx
     * @param el
     */
    TextOverflow.prototype.clamp = function (idx, el) {
        /**
         * Dotdotdot will automatically grab the max-height set in CSS
         */
        $(el).dotdotdot({
            watch: true,
            after: '<svg width="13px" height="14px" viewBox="0 0 13 14" xmlns="http://www.w3.org/2000/svg"><title>Path 2</title><g fill-rule="evenodd"><g transform="translate(-1317.000000, -527.000000)" ><polyline points="1317.06982 533.641602 1326.39787 533.641602 1321.70011 528.943842 1322.70811 527.935846 1329.21734 534.445074 1322.70275 540.959662 1321.75939 540.016301 1326.42721 535.348476 1317.10711 535.348476"/></g></g></svg>'
        });
    };

    /**
     * Return if clampable
     *
     * @param idx
     * @param el
     * @returns {boolean}
     */
    TextOverflow.prototype.isClampable = function(idx, el) {
        return $(el)
                .pseudoProperty('after', 'content')
                .indexOf('text-overflow:') === 0;
    };

    TextOverflow.prototype.builder = function () {
        var textOverflow = new TextOverflow();
        $('*')
            .filter(textOverflow.isClampable)
            .map(textOverflow.clamp);
    };

    return TextOverflow;
})(jQuery);
